const profileIds = [
    { label: '2', value: 2 },
    { label: '9', value: 9 },
    { label: '43', value: 43 },
    { label: '136', value: 136 },
];

const sensorTypeLabels = {
    2:   [{ label: 'Ambient Temperature', value: 'Ambient Temperature' }],
    9:   [{ label: 'Open_Closed', value: 'Open_Closed' }],
    43:  [{ label: 'Humidity', value: 'Humidity' },{ label: 'Temperature', value: 'Temperature' }],
    136: [{ label: 'Digital Probe Temperature', value: 'Digital Probe Temperature' }],
};

const sensorTypeUnits = {
    'Ambient Temperature': [{ label: '°C', value: '°C' }, { label: '°F', value: '°F' }],
    'Humidity':    [{ label: '%', value: '%' }],
    'Temperature': [{ label: '°C', value: '°C' }, { label: '°F', value: '°F' }],
    'Open_Closed':        [],
    'Digital Probe Temperature': [{ label: '°C', value: '°C' }, { label: '°F', value: '°F' }],
};

const config = {
    title: 'Sensor Type',
    defaultSort: 'label',
    module: 'sensorType',
    normalizeRecord: function (record) {
        if (!record) return record;
        const validUnits = sensorTypeUnits[record.label];
        if (validUnits === undefined) return record;
        if (validUnits.length === 0) {
            return { ...record, unit: '-' };
        }
        if (!validUnits.find(u => u.value === record.unit)) {
            return { ...record, unit: validUnits[0].value };
        }
        return record;
    },
    columns: [
        {
            field: "profileId", flex: 1, header: "Profile Id", lookup: profileIds, required: true, maxWidth: 220,
            onChange: function (e, formik) {
                const labels = sensorTypeLabels[e.target.value];
                const firstLabel = labels && labels.length > 0 ? labels[0].value : '';
                formik.setFieldValue('label', firstLabel);
                const units = sensorTypeUnits[firstLabel];
                formik.setFieldValue('unit', units && units.length > 0 ? units[0].value : '-');
            }
        },
        {
            field: "label", flex: 1, header: "Sensor Type", required: true, minLength: 2, maxLength: 50, maxWidth: 350, hideable: false, uniqueWith: ['profileId'],
            onChange: function (e, formik) {
                const units = sensorTypeUnits[e.target.value];
                formik.setFieldValue('unit', units && units.length > 0 ? units[0].value : '-');
            },
            hideConfig: {
                onHide: function ({ formValues, column }) {
                    const lookup = sensorTypeLabels[formValues && formValues.profileId] || [];
                    return { isHide: false, column: { ...column, lookup } };
                }
            }
        },
        {
            field: "unit", flex: 1, header: "Unit of measurement", maxLength: 50, nullable: true,
            hideConfig: {
                onHide: function ({ formValues, column }) {
                    const lookup = sensorTypeUnits[formValues && formValues.label];
                    if (!lookup || lookup.length === 0) {
                        return { isHide: false, column: { ...column, lookup: undefined, readOnly: true } };
                    }
                    return { isHide: false, column: { ...column, lookup } };
                }
            }
        },
        {
            field: "isDuration", type: "boolean", header: "Duration?",
            hideConfig: {
                onHide: function ({ formValues, column }) {
                    return { isHide: false, column: { ...column, readOnly: formValues?.profileId !== 9 } };
                }
            }
        }
    ],
    relations: [
        'sensor'
    ]
};

export default config;